export default __webpack_public_path__ + "static/product-3e71f2275398a5e018148d812126451d.jpg";